import dayjs from 'dayjs';

import { DATE_TIME_NO_SEC } from '@cast/constants';

export const formatAnalyzePromptDateRange = ({
  from,
  to,
}: {
  from: number;
  to: number;
}): string => {
  const start = dayjs.utc(from).format(DATE_TIME_NO_SEC);
  const end = dayjs.utc(to).format(DATE_TIME_NO_SEC);
  return `${start} to ${end}`;
};

export type BuildAnalyzePromptOptions = {
  context: string;
  getDefaultRange: (() => { from: string; to: string }) | undefined;
  scopeName?: string;
};

export const buildAnalyzePrompt =
  ({ context, scopeName, getDefaultRange }: BuildAnalyzePromptOptions) =>
  (range?: { from: number; to: number }): string => {
    const scope = scopeName ? `${scopeName} ` : '';
    let resolvedRange = range;
    if (!resolvedRange && getDefaultRange) {
      const { from, to } = getDefaultRange();
      resolvedRange = { from: dayjs(from).valueOf(), to: dayjs(to).valueOf() };
    }

    const timeRange =
      resolvedRange?.from != null && resolvedRange?.to != null
        ? formatAnalyzePromptDateRange(resolvedRange)
        : 'the selected time range';
    return `Analyze the ${scope}${context} from ${timeRange}.`;
  };
